import * as React from "react"
import * as TabsPrimitive from "@radix-ui/react-tabs"

import { cn } from "@/lib/utils"


const TabsVertical = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Root>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Root
    ref={ref}
    orientation="vertical"
    className={cn('flex flex-row', className)}
    {...props}
  />
))
TabsVertical.displayName = TabsPrimitive.Root.displayName


const TabsVerticalList = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.List>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.List>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    className={cn("flex h-max flex-col gap-1 p-0", className)}
    {...props}
  />
))
TabsVerticalList.displayName = TabsPrimitive.List.displayName

const TabsVerticalTrigger = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn("fc-side-tab w-full focus-visible:outline-none focus-visible:shadow-fc-focus disabled:pointer-events-none disabled:opacity-40", className)}
    {...props}
  />
))
TabsVerticalTrigger.displayName = TabsPrimitive.Trigger.displayName

const TabsVerticalContent = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Content>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Content
    ref={ref}
    className={cn(
      "ml-2 w-full animate-fc-tab-in focus-visible:outline-none",
      className
    )}
    {...props}
  />
))
TabsVerticalContent.displayName = TabsPrimitive.Content.displayName

export { TabsVertical, TabsVerticalList, TabsVerticalTrigger, TabsVerticalContent }
